import { CurrencyType } from 'src/graphql'
import { OrderWithPartialLines } from 'src/redux/reducers/orders'

const willUsePoints = (order: OrderWithPartialLines) => {
  for (const total of order.cost.total) {
    if (
      total.currency === CurrencyType.POINT ||
      total.currency === CurrencyType.EXPENSE
    ) {
      return true
    }
  }
  return false
}

export default willUsePoints
